import { render } from "./functionalAdministartion.vue?vue&type=template&id=58ebb94a&scoped=true"
import script from "./functionalAdministartion.vue?vue&type=script&lang=js"
export * from "./functionalAdministartion.vue?vue&type=script&lang=js"

import "./functionalAdministartion.vue?vue&type=style&index=0&id=58ebb94a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ebb94a"]])

export default __exports__